import {getViolationData, stpDashboardViolationCount} from '../../../api/adminDist/violationApi'
import {putLicensePlate} from '../../../api/eastCoastDataApi/ElkQuery/VehicleElk'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  violationData: [],
  stdViolation: {}
}

const getters = {
  getViolationData(state){
    return state.violationData
  }
}

const actions = {
  async getViolationData({commit}, condition ={}) {
    const result = await getViolationData(condition)

    if(!Utils.isEmptyObject(result) && result.success) {
      commit('violationData', result.body)
    }
  },

  async getStdDashBoradViolation({commit}, condition ={}) {
    const result = await stpDashboardViolationCount(condition)
    commit('stdViolation', result)
  },

  async putLicensePlate({commit}, condition) {
    const result = await putLicensePlate(condition);
    if (result.success) {
      commit('updateViolationData', { data: condition, mode: 'put' });
    }
  },
  
}

const mutations = {
  violationData(state, data) {
    state.violationData = data
  },

  stdViolation(state, data) {
    if(Utils.isEmptyObject(data)) {
      state.stdViolation = {}
      return   
    }
    
    state.stdViolation = data
  },


  updateViolationData(state, { data, mode }) {
   switch(mode){
      case 'put':
        const index = state.violationData.findIndex(item => item.eventID === data.eventId);

        if (index !== -1) {
        state.violationData[index].licensePlate = data.license;
        }
        break
   }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}